import {useEffect,useRef,useState} from 'react';
import {API} from '../lib/api';
import {emptySignal,validSignalDraft} from '../lib/customerSignals';
import {holdDraftLock} from '../lib/handoverDraft';
import {browserScope} from '../lib/sessionScope';
import {randomId} from '../lib/randomId';

const fresh=()=>({...emptySignal(),rental_id:'',request_id:randomId()});
export default function useCustomerSignalDraft(userId,clientId,tenantId) {
  const key=`autotu:customer-signal:v1:${JSON.stringify(browserScope(API,userId,tenantId,clientId))}`;
  const [initial]=useState(()=>{
    let raw=null;
    try {
      raw=localStorage.getItem(key);const stored=raw===null?null:JSON.parse(raw);
      if(stored&&(!validSignalDraft(stored.form)||stored.version!==1||typeof stored.form.rental_id!=='string'||typeof stored.form.request_id!=='string'))throw new Error('Bozza non leggibile. Non è stata sovrascritta.');
      return {raw,form:stored?.form||fresh(),recovered:!!stored};
    } catch(e){return {raw,form:fresh(),error:e.message};}
  });
  const [form,setForm]=useState(initial.form),[error,setError]=useState(initial.error||''),[saved,setSaved]=useState(initial.recovered),[locked,setLocked]=useState(true),[lockError,setLockError]=useState('');
  const raw=useRef(initial.raw),corrupt=useRef(!!initial.error),current=useRef(initial.form),allowed=useRef(false);
  useEffect(()=>{const release=holdDraftLock(key,message=>{allowed.current=!message;setLocked(!!message);setLockError(message);});return()=>{allowed.current=false;release();};},[key]);
  useEffect(()=>{const changed=e=>{if(e.storageArea===localStorage&&(e.key===key||e.key===null)){allowed.current=false;setLocked(true);setLockError('La bozza è cambiata in un’altra scheda. Ricarica per recuperarla.');}};window.addEventListener('storage',changed);return()=>window.removeEventListener('storage',changed);},[key]);
  const persist=next=>{
    if(!allowed.current||corrupt.current)return false;
    current.current=next;setForm(next);
    try {
      if(localStorage.getItem(key)!==raw.current)throw new Error('La bozza è cambiata in un’altra scheda. Ricarica prima di continuare.');
      const value=JSON.stringify({version:1,form:next});localStorage.setItem(key,value);raw.current=value;setError('');setSaved(true);return true;
    } catch(e){setError('Bozza non salvata: '+e.message);return false;}
  };
  const reset=()=>{
    if(!allowed.current)return false;
    try {
      if(localStorage.getItem(key)!==raw.current)throw new Error('La bozza è cambiata in un’altra scheda.');
      localStorage.removeItem(key);raw.current=null;corrupt.current=false;current.current=fresh();setForm(current.current);setError('');setSaved(false);return true;
    }catch(e){setError(e.message);return false;}
  };
  return {form,change:persist,retry:()=>persist(current.current),reset,error,saved,locked:locked||corrupt.current,lockError,recovered:initial.recovered};
}
